// Row logic for the Team members list: sign-in, employment type and salary display.

// /api/users answers snake_case (login_enabled); a user without the field can sign in.
export const isLoginEnabled = (user) => (user?.login_enabled ?? user?.loginEnabled) !== false;

// A person without a login has no username.
export const displayUsername = (user) => (isLoginEnabled(user) ? (user?.username || '—') : '—');

// Owner is the partner link, not a stored type; a member without a staff profile yet counts as an employee.
export const employmentTypeOf = (user, profile, partner = null) => (partner ? 'OWNER' : (profile?.employmentType || 'EMPLOYEE'));

const formatAed = (value) => `AED ${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const salaryLabel = (profile, canSeeSalary) => {
  const total = profile?.currentSalary?.total;
  return canSeeSalary && total != null ? formatAed(total) : '—';
};

// typeFilter: '' (all), an employment type, or 'NO_LOGIN'.
export const matchesTypeFilter = (user, profile, typeFilter, partner = null) => {
  if (!typeFilter) return true;
  if (typeFilter === 'NO_LOGIN') return !isLoginEnabled(user);
  return employmentTypeOf(user, profile, partner) === typeFilter;
};

// Partner rows a member can be the owner of: active, and not linked to someone else. Set-up is offered only when the
// TC has no active partners (BE-12 needs exactly 100% before drawings).
export const ownerOptions = (partners = [], links = [], userId = null) => {
  const active = partners.filter((p) => p.active !== false);
  const linkedTo = Object.fromEntries(links.map((l) => [l.partnerId, l.userId]));
  const mine = links.find((l) => userId && l.userId === userId) || null;
  return {
    partners: active
      .filter((p) => !linkedTo[p.id] || linkedTo[p.id] === userId)
      .map((p) => ({ id: p.id, name: p.name, label: `${p.name} · ${Number(p.ownershipPercent)}%` })),
    currentPartnerId: mine ? mine.partnerId : null,
    canSetUp: active.length === 0,
  };
};
